// components/RequireRole.js
import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";

const RequireRole = ({ allowedRoles, children }) => {
    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem("authUser"));
        if (userData) {
            setUserRole(userData.user_ROLE_ID);
        }
    }, []);

    // en attente du chargement
    if (userRole === null) return null;

    if (!allowedRoles.includes(userRole)) {
        return <Navigate to="/landing" replace />;
    }

    return children;
};

export default RequireRole;


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license